'use client'
import { useContext } from 'react'
import { PageTransitionContext } from '@/context/base/PageTransitionContext'

export const usePageTransition = () => {
  const { transitionName, setTransitionName, cortinaTransitionName, setCortinaTransitionName, targetHref, setTargetHref, isLoading, setIsLoading } = useContext(PageTransitionContext)
  return { transitionName, setTransitionName,  cortinaTransitionName, setCortinaTransitionName, targetHref, setTargetHref, isLoading, setIsLoading }
}
